import { NOTIFICATION_TYPE, Store } from "react-notifications-component";

export function getDateWithDay(date: string) {
    const newDate = new Date(date)
    return `${newDate.getDate() > 9 ? newDate.getDate() : '0' + newDate.getDate()}/${newDate.getMonth() + 1 >= 10 ? newDate.getMonth() + 1 : '0' + (newDate.getMonth() + 1)}/${newDate.getFullYear()}`
}

export function getDateWithDayEN(date: string) {
    const newDate = new Date(date)
    return `${newDate.getFullYear()}-${(newDate.getMonth() + 1) >= 10 ? newDate.getMonth() + 1 : '0' + (newDate.getMonth() + 1)}-${newDate.getDate() > 9 ? newDate.getDate() : '0' + newDate.getDate()}`
}

export function getDateTimeWithDayEN(date: string) {
    const newDate = new Date(date)
    return `${newDate.getFullYear()}-${(newDate.getMonth() + 1) >= 10 ? newDate.getMonth() + 1 : '0' + (newDate.getMonth() + 1)}-${newDate.getDate() > 9 ? newDate.getDate() : '0' + newDate.getDate()}T00:01`
}

export function getDatesBetweenDates(startDate: Date, endDate: Date) {
    let dates: Date[] = []
    //to avoid modifying the original date
    const theDate = new Date(startDate)

    while (theDate < endDate) {
        dates = [...dates, new Date(theDate)]
        theDate.setDate(theDate.getDate() + 1)
    }
    dates = [...dates]
    return dates
}

export function getAmount(amount: number, currency_code: string) {
    return amount && currency_code ? amount.toLocaleString(navigator.language, {
        style: "currency",
        currency: currency_code,
    }) : amount;
}


export function addNotification(type: NOTIFICATION_TYPE, message: string) {
    Store.addNotification({
        title: type,
        message: message,
        type: type,
        container: "top-right",
        dismiss: {
            duration: 5000,
            onScreen: true
        }
    });
}